"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeitungPrismaSchema = void 0;
const zod_1 = require("zod");
const NullableJsonValue_1 = require("../inputTypeSchemas/NullableJsonValue");
const InputJsonValue_1 = require("../inputTypeSchemas/InputJsonValue");
const DataSourceSchema_1 = require("../inputTypeSchemas/DataSourceSchema");
const ArticleSpecSchema_1 = require("../inputTypeSchemas/ArticleSpecSchema");
const ArticleTypeSchema_1 = require("../inputTypeSchemas/ArticleTypeSchema");
/////////////////////////////////////////
// LEITUNG PRISMA SCHEMA
/////////////////////////////////////////
exports.LeitungPrismaSchema = zod_1.z.object({
    DataSource: DataSourceSchema_1.DataSourceSchema,
    ArticleSpecs: ArticleSpecSchema_1.ArticleSpecSchema.array(),
    ArticleType: ArticleTypeSchema_1.ArticleTypeSchema,
    BaseArticleRef: NullableJsonValue_1.NullableJsonValue.optional(),
    AkeneoSku: zod_1.z.string(),
    AkeneoUuid: zod_1.z.string().nullish(),
    DiscontinuedModel: zod_1.z.boolean(),
    EchainId: zod_1.z.string(),
    SerieRef: NullableJsonValue_1.NullableJsonValue.optional(),
    FreigabeECF: zod_1.z.boolean(),
    FreigabeEIC: zod_1.z.boolean(),
    FreigabeEIQ: zod_1.z.boolean(),
    FreigabeEKE: zod_1.z.boolean(),
    Aderzahl: zod_1.z.string(),
    AderzahlBerechnet: zod_1.z.number().int().nullish(),
    ArtNr: InputJsonValue_1.InputJsonValue,
    ArtNrDE: zod_1.z.string().nullish(),
    ArtNrUS: zod_1.z.string().nullish(),
    Aussendurchmesser: InputJsonValue_1.InputJsonValue,
    Bezeichnung: InputJsonValue_1.InputJsonValue,
    BiegeradiusMin: InputJsonValue_1.InputJsonValue,
    GewichtKgProKm: InputJsonValue_1.InputJsonValue,
    Kupferzahl: NullableJsonValue_1.NullableJsonValue.optional(),
    Leitungsaufbau: NullableJsonValue_1.NullableJsonValue.optional(),
    Querschnitt: InputJsonValue_1.InputJsonValue,
    RAL_Nummer: zod_1.z.string(),
    Categories: zod_1.z.string().array(),
    MainCategory: zod_1.z.string(),
    FreitragenderBetriebErlaubt: zod_1.z.boolean(),
    AuhiFreitragendA: NullableJsonValue_1.NullableJsonValue.optional(),
    AuhiFreitragendV: NullableJsonValue_1.NullableJsonValue.optional(),
    VerfahrwegFreitragendMax: NullableJsonValue_1.NullableJsonValue.optional(),
    AuhiGleitend: zod_1.z.boolean(),
    AuhiGleitendA: NullableJsonValue_1.NullableJsonValue.optional(),
    AuhiGleitendV: NullableJsonValue_1.NullableJsonValue.optional(),
    VerfahrwegGleitendMax: NullableJsonValue_1.NullableJsonValue.optional(),
    HaengenderBetriebErlaubt: zod_1.z.boolean(),
    BeschleunigungHaengendMax: NullableJsonValue_1.NullableJsonValue.optional(),
    GeschwindigkeitHaengendMax: NullableJsonValue_1.NullableJsonValue.optional(),
    VerfahrwegHaengendMax: NullableJsonValue_1.NullableJsonValue.optional(),
    AuhiTemperaturMax: InputJsonValue_1.InputJsonValue,
    AuhiTemperaturMin: InputJsonValue_1.InputJsonValue,
    BusSystem: NullableJsonValue_1.NullableJsonValue.optional(),
    DESINA: zod_1.z.boolean(),
    DNV_GL: zod_1.z.boolean(),
    EAC: zod_1.z.boolean(),
    Flammwidrig: zod_1.z.boolean(),
    Gesamtschirm: zod_1.z.boolean(),
    Halogenfrei: zod_1.z.boolean(),
    Kuehlmittelbestaendig: zod_1.z.boolean(),
    MUDBestaendig: zod_1.z.boolean(),
    Mantelwerkstoff: zod_1.z.string(),
    Oelbestaendigkeit: zod_1.z.string(),
    Reinraum: zod_1.z.boolean(),
    Schirmung: zod_1.z.boolean(),
    Torsionsfaehig: zod_1.z.boolean(),
    Torsionswinkel: NullableJsonValue_1.NullableJsonValue.optional(),
    TwistedPair: zod_1.z.boolean(),
    UL_CSA: zod_1.z.boolean(),
    UVBestaendigkeit: zod_1.z.string(),
    Ungeschirmt: zod_1.z.boolean(),
    FesteLaenge: zod_1.z.boolean(),
    Leitungslaenge: NullableJsonValue_1.NullableJsonValue.optional(),
    HatStecker: zod_1.z.boolean(),
    Stecker1: NullableJsonValue_1.NullableJsonValue.optional(),
    Stecker2: NullableJsonValue_1.NullableJsonValue.optional(),
    SubCategory: zod_1.z.string().nullish(),
    Manufacturer: zod_1.z.string().nullish(),
    ManufacturerPartNo: zod_1.z.string().nullish(),
});
exports.default = exports.LeitungPrismaSchema;
//# sourceMappingURL=LeitungPrismaSchema.js.map